import { Customer } from "./Customer";
import { Product } from "./Product";
import { Transaction } from "./Transaction";

export interface Order {
  _id: string;
  orderId: number
  customer?: Customer;
  product: Product;
  qty: number;
  transaction: Transaction;
  status: OrderStatus;
  selected?: boolean
  createdAt: Date;
}
export enum OrderStatus {
  CONFIRMED = "confirmed",
  PENDING = "pending",
  CANCELLED = "canceled",
}

export interface UpdateOrderModel {
  status?: OrderStatus;
}
